import { styled } from 'styled-components';
export const AlertBannerMessage = styled.div.withConfig({
  displayName: "AlertBannerMessage",
  componentId: "asurion-ui-react__sc-ecfq4w-0"
})(["line-height:1.5;padding:1rem;flex-grow:1;"]);
export const AlertBannerMessageText = styled.p.withConfig({
  displayName: "AlertBannerMessageText",
  componentId: "asurion-ui-react__sc-ecfq4w-1"
})(["margin-bottom:0;margin-top:0;"]);